import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { MatTooltipModule, MatTooltip } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OnlyNumbersDirective } from '../../directives/only-numbers.directive';
import { AnosReferenciasService } from '../../services/anos-referencias/anos-referencias.service';
import { AnosReferenciasDto } from '../../dtos/anos-referencias.dto';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import { FonteNotaInterface } from '../../shared/rodape-fonte-nota/fonte-nota.interface';
import { MenuSuspensoComponent } from '../../shared/menu-suspenso/menu-suspenso.component';
import { RodapeFonteNotaComponent } from '../../shared/rodape-fonte-nota/rodape-fonte-nota.component';
import { LayoutEditorContentService, IconeAtivo } from '../../layouts/layout-editor/layout-editor-content.service';
import { DialogRestaurarValoresComponent } from '../../shared/dialog-restaurar-valores/dialog-restaurar-valores.component';
import { DialogPqrPadraoTamanhoDasTurmasComponent } from '../../shared/dialog-pqr-padrao-tamanho-das-turmas/dialog-pqr-padrao-tamanho-das-turmas.component';
import { MediaAlunosPorTurmaDto } from '../../dtos/media-alunos-por-turma.dto';
import { MediaAlunosPorTurmaService } from '../../services/media-alunos-por-turma/media-alunos-por-turma.service';
import { mask_porcentagem_limpa } from '../../directives/mascaras';
import { maskitoTransform } from '@maskito/core';
import { CondicaoQualidadeStateService, EtapasDeEdicaoService, LocalizacaoService } from '../../services';
import { PQRTamanhoTurmaDto, TipoEtapaEnsinoSimcaqTurmaDto, TipoLocalizacaoDto } from '../../dtos';
import { PQRTamanhoMinimoTurmaDto } from '../../dtos/pqr-tamanho-minimo-turma.dto';
import { LocalizacaoSelecionada } from '../../interfaces/location.interface';
import { TipoSimulacao } from '../../enums/simulation-type.enum';

enum EtapaEnsinoPqr {
  Creche = 1,
  PreEscola = 2,
  EnsFunAnosIniciais = 3,
  EnsFunAnosFinais = 4,
  EnsMedio = 5,
  Eja = 6,
  Creche_menor1ano = 10,
  Creche_1ano = 11,
  Creche_2anos = 12,
  Creche_3anos = 13
}

type TamanhoTurmasData = {
  id: number;
  etapa: TipoEtapaEnsinoSimcaqTurmaDto;
  localizacao: TipoLocalizacaoDto;
  idMinimoTurma: number;
  minimoTurmas: number;
  minimoMatriculasPorTurma: number;
  numAlunos: number;
  numDocentes: number;
  mediaAlunos: string | null;
};

@Component({
  selector: 'app-tamanho-das-turmas',
  standalone: true,
  imports: [
    FormsModule,
    MatIconModule,
    MatDialogModule,
    TabelaComponent,
    NgFor,
    MatTooltipModule,
    MenuSuspensoComponent,
    OnlyNumbersDirective,
    NgIf,
    RodapeFonteNotaComponent,
    ReactiveFormsModule
  ],
  templateUrl: './tamanho-das-turmas.component.html',
  styleUrl: './tamanho-das-turmas.component.scss',
})
export class TamanhoDasTurmasComponent implements OnInit{
  @ViewChild('infoTooltip') infoTooltip!: MatTooltip;
  @ViewChild('menuTooltip') menuTooltip!: MatTooltip;

  dadosTabelaUrbana: TamanhoTurmasData[] = [];
  dadosTabelaRural: TamanhoTurmasData[] = [];
  mediaAlunosPorEtapa: MediaAlunosPorTurmaDto[] = [];

  menuTooltipVisible = false;
  anosReferencias: AnosReferenciasDto | null = null;
  anoCenso: number;

  notasFonte: FonteNotaInterface[] = [
    {
      titulo: 'Fonte',
      conteudos: [
        {
          numero: 1,
          descricao:
            'Elaborado a partir dos dos microdados do Censo Escolar/INEP 2025.',
        },
      ],
    },
    {
      titulo: 'Notas',
      conteudos: [
        {
          numero: 2,
          descricao:
            'O cálculo da média do número de alunos por turma não considera matrículas em unidades socioeducativas/prisionais, hospitalares, de atendimento educacional especializado e atividade complementar.',
        },
      ],
    },
  ];

  typeOf(value: string | undefined) {
    return typeof value;
  }

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private dialogRestaurarValores: MatDialog,
    private dialogPqrPadraoTamanhoDasTurmas: MatDialog,
    private mediaAlunosPorTurmaService: MediaAlunosPorTurmaService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
    private localizacaoService: LocalizacaoService,
    private anosReferenciasService: AnosReferenciasService,
    public featureFlagService: FeatureFlagService
  ) {
    if (this.featureFlagService.funcionalidadeHabilitada('940-atualizacao-de-componentes-de-edicao-pqr')) {
      this.anosReferencias = this.anosReferenciasService.obterAnosReferenciasSnapshot();
    }
    this.anoCenso = this.anosReferencias?.anoCenso ?? 2025;
    this.notasFonte[0].conteudos[0].descricao = `Elaborado a partir dos dos microdados do Censo Escolar/INEP ${this.anoCenso}.`;
  }

  async ngOnInit(): Promise<void> {
    if (this.condicaoQualidadeStateService.carregando.getValue()) {
      this.condicaoQualidadeStateService.carregando.subscribe(async () => {
        await this.carregueMediaAlunosPorTurma();

        const dados = this.condicaoQualidadeStateService.getPQRTamanhoTurmasValores();
        const dadosMinimos = this.condicaoQualidadeStateService.getPQRMinimoTurmasValores();
        this.dadosTabelaUrbana = this.carregarDados(dados, dadosMinimos, 1);
        this.dadosTabelaRural = this.carregarDados(dados, dadosMinimos, 2);
        return;
      });
    }

    await this.carregueMediaAlunosPorTurma();

    const dados = this.condicaoQualidadeStateService.getPQRTamanhoTurmasValores();
    const dadosMinimos = this.condicaoQualidadeStateService.getPQRMinimoTurmasValores();
    this.dadosTabelaUrbana = this.carregarDados(dados, dadosMinimos, 1);
    this.dadosTabelaRural = this.carregarDados(dados, dadosMinimos, 2);
  }

  carregarDados(
    dadosPQR: PQRTamanhoTurmaDto[],
    dadosMinimosPQR: PQRTamanhoMinimoTurmaDto[],
    codLocalizacao: 1 | 2
  ): TamanhoTurmasData[] {
    const deparaEtapaEnsinoPqr: Record<number, number> = {
      [EtapaEnsinoPqr.Creche]: 1,
      [EtapaEnsinoPqr.Creche_menor1ano]: 10,
      [EtapaEnsinoPqr.Creche_1ano]: 11,
      [EtapaEnsinoPqr.Creche_2anos]: 12,
      [EtapaEnsinoPqr.Creche_3anos]: 13,
      [EtapaEnsinoPqr.PreEscola]: 2,
      [EtapaEnsinoPqr.EnsFunAnosIniciais]: 3,
      [EtapaEnsinoPqr.EnsFunAnosFinais]: 4,
      [EtapaEnsinoPqr.EnsMedio]: 5,
      [EtapaEnsinoPqr.Eja]: 6,
    };

    const medias = this.mediaAlunosPorEtapa?.find(m => m.tipoLocalizacao === codLocalizacao);

    const flagsCrecheSegregadaAtivas =
      this.featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma') &&
      this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade');

    const codigosEtapasCrecheSegregada = [10, 11, 12, 13];
    const codigoEtapaCrecheAgregada = 1;

    const resultado = dadosPQR
      .filter(pqr => pqr.tipoLocalizacao.codTipoLocalizacao === codLocalizacao)
      .map(pqr => {
        const etapaEnsino = deparaEtapaEnsinoPqr[pqr.etapaEnsino.codEtapaEnsino];
        const mediaAlunosPorTurma = this.pegarMediaDaEtapa(medias, etapaEnsino);
        const dadoMinimo = dadosMinimosPQR.find(minimo =>
          minimo.etapaEnsino.codEtapaEnsino === pqr.etapaEnsino.codEtapaEnsino
        );

        return {
          id: pqr.codPqrTamanhoTurma,
          etapa: pqr.etapaEnsino,
          localizacao: pqr.tipoLocalizacao,
          idMinimoTurma: dadoMinimo?.codPqrTamanhoMinimoTurma ?? 0,
          minimoTurmas: dadoMinimo?.qntMinimaTurma ?? 0,
          minimoMatriculasPorTurma: dadoMinimo?.qntMinimaAlunosTurma ?? 0,
          numDocentes: pqr.qntDocentesTurma,
          numAlunos: pqr.qntAlunosTurma,
          mediaAlunos: mediaAlunosPorTurma != null
            ? maskitoTransform(String(mediaAlunosPorTurma), mask_porcentagem_limpa)
            : '',
          _codEtapa: deparaEtapaEnsinoPqr[pqr.etapaEnsino.codEtapaEnsino]
        } as TamanhoTurmasData & { _codEtapa: number };
      });

    const filtrado = resultado.filter(d => {
      if (flagsCrecheSegregadaAtivas) {
        return d._codEtapa !== codigoEtapaCrecheAgregada;
      }
      return !codigosEtapasCrecheSegregada.includes(d._codEtapa);
    });

    filtrado.sort((a, b) => {
      const prioridade = (cod: number) => {
        if (flagsCrecheSegregadaAtivas && codigosEtapasCrecheSegregada.includes(cod)) {
          return -1;
        }
        return 0;
      };
      const pa = prioridade(a._codEtapa);
      const pb = prioridade(b._codEtapa);
      if (pa !== pb) return pa - pb;
      return a._codEtapa - b._codEtapa;
    });

    return filtrado;
  }

  ehPrimeiraCrecheSegregada(dados: TamanhoTurmasData): boolean {
    return (dados as any)._codEtapa === 10;
  }

  ehCrecheSegregadaOculta(dados: TamanhoTurmasData): boolean {
    return [11, 12, 13].includes((dados as any)._codEtapa);
  }

  carregarDadosUrbana(dadosPQR: PQRTamanhoTurmaDto[]) {
    const deparaEtapaEnsinoPqr: any = {};
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Creche] = 1;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Creche_menor1ano] = 10;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Creche_1ano] = 11;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Creche_2anos] = 12;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Creche_3anos] = 13;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.PreEscola] = 2;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.EnsFunAnosIniciais] = 3;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.EnsFunAnosFinais] = 4;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.EnsMedio] = 5;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Eja] = 6;

    // linha de médias para Urbana (1)
    const mediasUrbana = this.mediaAlunosPorEtapa?.find(media => media.tipoLocalizacao === 1);

    this.dadosTabelaUrbana = dadosPQR
      .filter(pqr => pqr.tipoLocalizacao.codTipoLocalizacao == 1)
      .map(pqr => {
        const etapaEnsino: number = deparaEtapaEnsinoPqr[pqr.etapaEnsino.codEtapaEnsino];

        // obtem os valores conforme a etapa etapa
        const mediaAlunosPorTurma = this.pegarMediaDaEtapa(mediasUrbana, etapaEnsino);

        const data: TamanhoTurmasData = {
          id: pqr.codPqrTamanhoTurma,
          etapa: pqr.etapaEnsino,
          localizacao: pqr.tipoLocalizacao,
          idMinimoTurma: 0,
          minimoTurmas: 0,
          minimoMatriculasPorTurma: 0,
          numDocentes: pqr.qntDocentesTurma,
          numAlunos: pqr.qntAlunosTurma,
          mediaAlunos: mediaAlunosPorTurma != null
            ? maskitoTransform(String(mediaAlunosPorTurma), mask_porcentagem_limpa)
            : ''
        };
        return data;
      });
  }

  carregarDadosRural(dadosPQR: PQRTamanhoTurmaDto[]) {
    const deparaEtapaEnsinoPqr: any = {};
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Creche] = 1;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Creche_menor1ano] = 10;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Creche_1ano] = 11;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Creche_2anos] = 12;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Creche_3anos] = 13;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.PreEscola] = 2;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.EnsFunAnosIniciais] = 3;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.EnsFunAnosFinais] = 4;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.EnsMedio] = 5;
    deparaEtapaEnsinoPqr[EtapaEnsinoPqr.Eja] = 6;

    // pega a linha de médias para Rural (2)
    const mediasRural = this.mediaAlunosPorEtapa?.find(m => m.tipoLocalizacao === 2);

    this.dadosTabelaRural = dadosPQR
      .filter(pqr => pqr.tipoLocalizacao.codTipoLocalizacao == 2)
      .map(pqr => {
        const etapaEnsino: number = deparaEtapaEnsinoPqr[pqr.etapaEnsino.codEtapaEnsino];
        const mediaAlunosPorTurma: number | null = this.pegarMediaDaEtapa(mediasRural, etapaEnsino);

        const data: TamanhoTurmasData = {
          id: pqr.codPqrTamanhoTurma,
          etapa: pqr.etapaEnsino,
          localizacao: pqr.tipoLocalizacao,
          idMinimoTurma: 0,
          minimoTurmas: 0,
          minimoMatriculasPorTurma: 0,
          numDocentes: pqr.qntDocentesTurma,
          numAlunos: pqr.qntAlunosTurma,
          mediaAlunos: mediaAlunosPorTurma != null
            ? maskitoTransform(String(mediaAlunosPorTurma), mask_porcentagem_limpa)
            : ''
        };
        return data;
      });
  }

  atualizarDadosDoServicoDeEstado() {
    const mapRow = (t: TamanhoTurmasData): PQRTamanhoTurmaDto => ({
      codPqrTamanhoTurma: t.id,
      etapaEnsino: {
        codEtapaEnsino: t.etapa?.codEtapaEnsino,
        descricao: t.etapa?.descricao,
      } as TipoEtapaEnsinoSimcaqTurmaDto,
      tipoLocalizacao: t.localizacao,
      qntAlunosTurma: t.numAlunos,
      qntDocentesTurma: t.numDocentes,
    });

    const mapMinimoRow = (t: TamanhoTurmasData): PQRTamanhoMinimoTurmaDto => ({
      codPqrTamanhoMinimoTurma: t.idMinimoTurma,
      etapaEnsino: {
        codEtapaEnsino: t.etapa?.codEtapaEnsino,
        descricao: t.etapa?.descricao,
      } as TipoEtapaEnsinoSimcaqTurmaDto,
      qntMinimaTurma: t.minimoTurmas,
      qntMinimaAlunosTurma: t.minimoMatriculasPorTurma,
    });

    const dadosDto = [
      ...this.dadosTabelaUrbana.map(mapRow),
      ...this.dadosTabelaRural.map(mapRow),
    ];

    const dadosMinimoDto = this.dadosTabelaUrbana.map(mapMinimoRow);

    this.condicaoQualidadeStateService.setPQRTamanhoTurmasValores(dadosDto);
    this.condicaoQualidadeStateService.setPQRMinimoTurmasValores(dadosMinimoDto);
  }


  async carregueMediaAlunosPorTurma(): Promise<void> {
    const localizacao = this.localizacaoService.obterLocalizacaoSelecionada();

    const codigoCidade = localizacao?.cidadeSelecionadaId;
    const codigoEstado = localizacao?.estadoSelecionado?.value
    const plano = localizacao?.tipoSimulacaoSelecionado;

    if( codigoCidade  ){
      this.mediaAlunosPorEtapa = await this.mediaAlunosPorTurmaService.buscarMediaAlunosPorTurmaMunicipal(codigoCidade, plano) || [];
      return;
    }

    if( codigoEstado ){
      this.mediaAlunosPorEtapa = await this.mediaAlunosPorTurmaService.buscarMediaAlunosPorTurmaEstadual(codigoEstado,plano) || [];
      return
    }

    this.mediaAlunosPorEtapa = await this.mediaAlunosPorTurmaService.buscarMediaAlunosPorTurmaNacional();

  }

  openDialogPqrValoresPadrao() {
    const dialogRef = this.dialogPqrPadraoTamanhoDasTurmas.open(
      DialogPqrPadraoTamanhoDasTurmasComponent,
      {
        panelClass: 'dialog-pqr-padrao-tamanho-das-turmas',
        position: { top: '2%' },
      },
    );

    const dialogInstance =
      dialogRef.componentInstance as DialogPqrPadraoTamanhoDasTurmasComponent;

    dialogInstance.dadosTabela = this.condicaoQualidadeStateService.getPQRTamanhoTurmasPadrao();
  }

  openDialogRestaurarValores() {
    const openedDialog = this.dialogRestaurarValores.open(
      DialogRestaurarValoresComponent,
      {
        panelClass: 'dialog-restaurar-valores',
        position: { top: '2%' },
      },
    );

    openedDialog.afterClosed().subscribe((result: any) => {
      if (result) {
        this.condicaoQualidadeStateService.setPQRTamanhoTurmasValores(
          JSON.parse(JSON.stringify(this.condicaoQualidadeStateService.getPQRTamanhoTurmasPadrao()))
        );

        this.condicaoQualidadeStateService.setPQRMinimoTurmasValores(
          JSON.parse(JSON.stringify(this.condicaoQualidadeStateService.getPQRMinimoTurmasPadrao()))
        );

        this.recarregarDados();
        this.toastr.success('Os valores foram restaurados', 'PQR!');
      }
    });
  }

  chamarAcao(acao: string) {
    if (acao === 'pqrDestaFuncionalidade') {
      this.pqrDestaFuncionalidade();
      return;
    }

    if (acao === 'restaurarValoresComBaseNoPqr') {
      this.restaurarValoresComBaseNoPqr();
      return;
    }

    if (acao === 'pqrCompletoEmNovaAba') {
      this.pqrCompletoEmNovaAba();
      return;
    }
  }

  pqrDestaFuncionalidade() {
    this.openDialogPqrValoresPadrao();
  }

  restaurarValoresComBaseNoPqr() {
    this.openDialogRestaurarValores();
  }

  pqrCompletoEmNovaAba() {
    const baseUrl = window.location.href.replace(this.router.url, '');
    const url = new URL('pqr', baseUrl).href;
    window.open(url, '_blank');
  }

  openTooltips() {
    this.menuTooltipVisible = true;
    setTimeout(() => {
      this.infoTooltip.show();
      this.menuTooltip.show();
    }, 100);
  }

  closeTooltips() {
    this.menuTooltipVisible = false;
    setTimeout(() => {
      this.infoTooltip.hide();
      this.menuTooltip.hide();
    }, 100);
  }

  private pegarMediaDaEtapa(
    medias: MediaAlunosPorTurmaDto | undefined,
    etapa: number
  ): number | null {
    if (!medias) return null;
    switch (etapa) {
      case 1:
      case 10:
      case 11:
      case 12:
      case 13:
        return medias.mediaAlunosPorTurmaCreche ?? null;
      case 2:
        return medias.mediaAlunosPorTurmaPreEscola ?? null;
      case 3:
        return medias.mediaAlunosPorTurmaEnsinoFundamentalAnosIniciais ?? null;
      case 4:
        return medias.mediaAlunosPorTurmaEnsinoFundamentalAnosFinais ?? null;
      case 5:
        return medias.mediaAlunosPorTurmaEnsinoMedio ?? null;
      case 6:
        return medias.mediaAlunosPorTurmaEja ?? null;
      default:
        return null;
    }
  }

  private recarregarDados() {
    const dados = this.condicaoQualidadeStateService.getPQRTamanhoTurmasValores();
    const dadosMinimos = this.condicaoQualidadeStateService.getPQRMinimoTurmasValores();
    this.dadosTabelaUrbana = this.carregarDados(dados, dadosMinimos, 1);
    this.dadosTabelaRural = this.carregarDados(dados, dadosMinimos, 2);
  }

}
